// Which filters apply given the others: e.g. Google's video length only
// works with video results. Hidden in the builder, an error in a typed bang.
import { isEmptyValue } from './params';
import type { Applicability, Condition, Param, Values } from './types';

function holds(c: Condition, values: Values): boolean {
  const v = values[c.param];
  const empty = isEmptyValue(v);
  if (c.unset) return empty;
  if (c.in) return empty ? !!c.orUnset : c.in.includes(String(v));
  return true;
}

export function applies(item: Applicability, values: Values): boolean {
  if (!item.when) return true;
  const conds = Array.isArray(item.when) ? item.when : [item.when];
  return conds.every(c => holds(c, values));
}

/**
 * Values with anything that no longer applies removed, plus what was removed.
 * Repeats until stable, since clearing one filter can make another apply.
 */
export function pruneInapplicable(
  params: Param[],
  values: Values
): { values: Values; removed: Param[] } {
  let next = { ...values };
  const removed: Param[] = [];
  for (let changed = true; changed; ) {
    changed = false;
    for (const param of params) {
      const v = next[param.id];
      if (isEmptyValue(v)) continue;
      const optionOk =
        param.type !== 'choice' ||
        applies(param.options.find(o => o.value === v) ?? {}, next);
      if (applies(param, next) && optionOk) continue;
      const { [param.id]: _drop, ...rest } = next;
      next = rest;
      removed.push(param);
      changed = true;
    }
  }
  return { values: next, removed };
}
